import React, { useRef, useState, useEffect, Fragment, useMemo, useCallback } from "react";

import { MapContainer, Marker, useMap } from "react-leaflet";

import { useLocation } from "react-router-dom";

import "leaflet-routing-machine/dist/leaflet-routing-machine.css";

import "leaflet-routing-machine";

import "leaflet/dist/leaflet.css";

import "leaflet-geosearch/assets/css/leaflet.css";

import "./Map.css";

import MapMarker from "./MapMarker";

import EventDetails from "../EventDetails/EventDetails";


import BottomSheet from "../BottomSheet/BottomSheet";

import MapTiles from "../MapTiles/MapTiles";

import DateFilterIndicator from "../DateFilterIndicator/DateFilterIndicator";

import InfiniteScroller from "../InfiniteScroller/InfiniteScroller";

import DatePickerFilter from "../DatePickerFilter/DatePickerFilter";

import EventCard from "../EventCard/EventCard";


import KitButton from "../kit/Button";
import Dropdown from "../kit/Dropdown";

import { useMediaQuery } from "../../util/useMediaQuery";

import Chip from "../kit/Chip";

import { useData } from "../../context/DataContext/DataProvider";
import { getCategoryPalette } from "../../util/categoryPalette";
import { openDirections } from "../../util/mapDirections";

import { useAnalytics } from "../../context/AnalyticsContext/AnalyticsProvider";

import Loader from "../icons/Loader";


import {

  createCategoryIcon,

  createImgIcon,

  createUserIcon,

  createVenueIcon,

} from "../../util/mapStyles";


import { useUIContext } from "../../context/UIContext/UIContext";

import { distance, isDefaultDateFilter } from "../../util/eventUtils";
import {
  fitMapToOverview,
  fitMapToNeighborhood,
  flyMapToLocation,
  findFirstFullyVisibleListItem,
  getListStickyOffset,
  LIST_SCROLL_TOP_THRESHOLD,
} from "../../util/mapViewport";

import { useOutsideAlerter } from "../../util/useOutsideAlerter";

import { getCurrentLocation } from "../../util/dataUtils";



import GlobalSearchFilters from "../GlobalSearchFilters/GlobalSearchFilters";

import { useEventDetailsSetters, useSelectedEventIds, EventDetailsContext } from "../../context/EventDetailsProvider/EventDetailsProvider";
import { useContextSelector } from "use-context-selector";

import { useMapContext } from "../../context/MapContext/MapContext";



import { DateTime } from "luxon";

import { createDebugLogger, DEBUG_EVENT_NAMES } from "../../util/debugUtils";

import DropDownInput from "../DropDownInput/DropDownInput";

import { backendUrl } from "../../api/constants";

import axiosInstance from "../../api/axiosInstance";

import Logo from "../icons/Logo";
import logoStatic from "../../assets/imgs/inyc_logo_notm.gif";

import PullToActionWrapper from "../PullToActionWrapper/PullToActionWrapper";

import { IoFilter } from "react-icons/io5";
import { FiHeart, FiNavigation } from "react-icons/fi";

import Icon from "../Icon/Icon";

import WJFIcon from "../../assets/icons/wjf-logo.png";

import { getKnownServiceImg } from "../../util/iconRegistry";

import { useAccountDetails } from "../../context/AccountDetailsContext/AccountDetailsProvider";

import AccountDetails from "../AccountDetails/AccountDetails";

import { MdCancel } from "react-icons/md";

import AccountCard from "../AccountCard/AccountCard";

import { StableTagProvider, StableTagList } from "../GlobalSearchFilters/StableTagFilters";



//#region //* =========================SETUP=========================

const TagFilter = ({ disabled, className, children, active, onClick, id }) => {

  return (

    <div

      id={id}

      onClick={() => {

        if (disabled) return;

        onClick && onClick();

      }}

              className={`text-center duration-300 font-['Primary-Medium'] flex justify-start items-center py-kit-6 px-kit-12 rounded-kit-full cursor-pointer border-[var(--inyc-input-border-color)] border-[1px] ${

        active

          ? "bg-[var(--inyc-secondary)] active !text-[--inyc-secondary-text-color]"

          : "bg-[var(--inyc-primary)]"

      } ${className} 

      ${disabled ? "opacity-50 pointer-events-none" : ""}

      `}

    >

      {children}

    </div>

  );

};



export const BottomSheetDateFilter = React.memo(({

  defaultDate = {

    start: DateTime.now().startOf("day").toJSDate(),

    end: DateTime.now().startOf("day").plus({ hours: 48 }).toJSDate(),

  },

  setFilterDate,

  filterDate,

  onCalendarIconClick,

  onMoreFiltersChange,

  className,

  tagFilter,

  style,

  setTagFilter,

  mapRef,

  hideFilterIcon = false,

  alwaysShowTags = false,

}) => {

  const [moreFiltersOpen, setMoreFiltersOpen] = useState(false);

  const [calendarOpen, setCalendarOpen] = useState(false);

  const datePickerRef = useRef();

  // Get knownServices directly from context - no need to pass as prop
  const { globalConfig } = useData();
  const knownServices = globalConfig?.knownServices || {};

  // Stable tag click handler using useCallback with proper dependencies
  const stableTagClickHandler = useCallback((tagId) => {
    const service = knownServices[tagId];
    if (!service) return;

    if (tagFilter.includes(tagId)) {
      // Removing tag - just remove from filter
      setTagFilter(tagFilter.filter(t => t !== tagId));
    } else {
      console.log("Adding tag to filter:", tagId);
      setTagFilter([...tagFilter, tagId]);
      
      // Auto-apply date range if service has one and we're using default filter
      if (service.dateRange) {
        console.log("Service has dateRange:", service.dateRange);
        if (isDefaultDateFilter(filterDate)) {
          console.log("Current filterDate is default, applying service dateRange");
          // Convert from service timezone to local timezone
          const serviceTimezone = service.dateRange.timezone || 'UTC';
          
          const startDate = DateTime.fromISO(service.dateRange.start, { zone: serviceTimezone })
            .setZone('local')
            .toJSDate();
          const endDate = DateTime.fromISO(service.dateRange.end, { zone: serviceTimezone })
            .setZone('local')
            .toJSDate();
          
          console.log("Setting filterDate to:", { start: startDate, end: endDate });
          setFilterDate({ start: startDate, end: endDate });
        } else {
          console.log("Current filterDate is NOT default, not applying service dateRange");
        }
      } else {
        console.log("Service does not have a dateRange");
      }

      // Auto-move map if service has a location
      if (service.location) {
        console.log("Service has location:", service.location);
        if (mapRef.current) {
          console.log("Moving map to location:", [service.location.lat, service.location.lng]);
          mapRef.current.flyTo([service.location.lat, service.location.lng], 13);
        }
      } else {
        console.log("Service does not have a location");
      }
    }
  }, [tagFilter, knownServices, filterDate, setTagFilter, setFilterDate, mapRef]);



  useEffect(() => {

    if (onMoreFiltersChange) {

      onMoreFiltersChange(moreFiltersOpen);

    }

  }, [moreFiltersOpen]);



  const handleDateTagClick = (e) => {

    filterDate === e.currentTarget.id

      ? setFilterDate(null)

      : setFilterDate(e.currentTarget.id);

  };



  useEffect(() => {

    if (datePickerRef?.current?.calendarOpen) {

      setCalendarOpen(true);

    } else {

      setCalendarOpen(false);

    }

  }, [datePickerRef?.current?.calendarOpen]);



  // Memoize formatted date calculation to avoid recalculating on every render
  let formattedDate = useMemo(() => {
    if (!filterDate?.start) return "today";

    const startDateString = filterDate.start.toLocaleDateString();
    const endDateString = filterDate.end?.toLocaleDateString();
    
    if (filterDate.end && endDateString !== startDateString) {
      return startDateString + " - " + endDateString;
    } else if (endDateString === startDateString) {
      const todayString = new Date().toLocaleDateString();
      const tomorrowString = new Date(Date.now() + 24 * 60 * 60 * 1000).toLocaleDateString();
      
      if (startDateString === todayString) {
        return "today";
      } else if (startDateString === tomorrowString) {
        return "tomorrow";
      } else {
        return startDateString;
      }
    }

    return startDateString;
  }, [filterDate?.start, filterDate?.end]);



  // console.log("filterDate ", filterDate?.start?.toLocaleDateString());

  // console.log(
  //   "defaultDate ",
  //   DateTime.now().startOf("day").toJSDate().toLocaleDateString()
  // );

  // console.log(
  //   "defaultDate ",
  //   DateTime.now()
  //     .startOf("day")
  //     .plus({ hours: 48 })
  //     .toJSDate()
  //     .toLocaleDateString()
  // );



  if (

    filterDate?.start?.toLocaleDateString() ===

      defaultDate.start.toLocaleDateString() &&

    filterDate?.end?.toLocaleDateString() ===

      defaultDate.end.toLocaleDateString()

  ) {

    formattedDate = "today";

  }



  // Memoize closeBtnShows calculation
  const closeBtnShows = useMemo(() => {
    if (calendarOpen || !filterDate?.start) return false;
    
    const startMatches = filterDate.start.toLocaleDateString() === defaultDate.start.toLocaleDateString();
    const endMatches = filterDate.end?.toLocaleDateString() === defaultDate.end.toLocaleDateString();
    
    return !(startMatches && endMatches);
  }, [calendarOpen, filterDate?.start, filterDate?.end, defaultDate.start, defaultDate.end]);



  return (

    <div

      style={style}

      className={`date-filter-container relative bottom-sheet-date-filter md:!translate-y-[-1rem] md:!left-0 md:!w-[30vw] md:!min-w-[100%] ${className}`}

    >


      <div

        className={`filter-option-flex h-fit date-filter duration-300`}

        id="date-picker"

      >

        {!hideFilterIcon && (
          <Chip
            aria-label="more filters"
            selected={Boolean(moreFiltersOpen || tagFilter.length > 0)}
            icon={<IoFilter size={16} />}
            onClick={() => setMoreFiltersOpen((prev) => !prev)}
          />
        )}

        <Chip
          id="now"
          selected={filterDate === "now"}
          onClick={handleDateTagClick}
        >
          now
        </Chip>

        <Chip
          id="soon"
          selected={filterDate === "soon"}
          onClick={handleDateTagClick}
        >
          soon
        </Chip>

        <Chip
          id="later"
          selected={filterDate === "later"}
          onClick={handleDateTagClick}
        >
          later
        </Chip>

        <Chip
          id="late night"
          selected={filterDate === "late night"}
          onClick={handleDateTagClick}
        >
          late night
        </Chip>

        <DatePickerFilter

          ref={datePickerRef}

          currentDate={filterDate}

          setCurrentDate={setFilterDate}

          onCalendarIconClick={onCalendarIconClick}

        />

      </div>

      <div

        className={`w-full grid mt-kit-8 overflow-hidden duration-300 ${

          (moreFiltersOpen || alwaysShowTags) ? "grid-rows-[1fr] mb-kit-16" : "grid-rows-[0fr]"

        } gap-kit-16`}

      >

        <div className="min-h-0">

          <StableTagProvider knownServices={knownServices}>
            <StableTagList 
              activeTags={tagFilter}
              onTagClick={stableTagClickHandler}
            />
          </StableTagProvider>

        </div>

      </div>

    </div>

  );

});






const newYorkCoords = {

  lat: 40.717426429835896,

  lng: -74.00518256903389,

};

const getMapItemLocation = (item) =>
  item?.effectiveLocation ||
  item?.location ||
  item?.venueDetails?.location ||
  item?.venue?.location ||
  item?._matchingEvent?.effectiveLocation ||
  item?._matchingEvent?.location ||
  item?._matchingEvent?.venueDetails?.location ||
  item?._matchingEvent?.venue?.location;

const getMapItemCoordinates = (item) => {
  const coordinates = getMapItemLocation(item)?.coordinates;
  return Array.isArray(coordinates) && coordinates.length >= 2
    ? coordinates
    : null;
};

//#endregion



//* =========================MAP=========================

const Map = () => {

  //#region variables
  
  // Create debug logger for this component
  const mapDebugLogger = createDebugLogger("Map");

  const { userLocation, setUserLocation, globalConfig } = useData();

  // Search functionality now comes from MapContext

  const categories = globalConfig?.categories;

  // Memoize knownServices to prevent recreation of empty object
  const knownServices = useMemo(() => {
    return globalConfig?.knownServices || {};
  }, [globalConfig?.knownServices]);

  const medium = useMediaQuery("md");

  
  // Ref for DatePickerFilter in GlobalSearchFilters (list panel)
  const listPanelDatePickerRef = useRef();
  // Ref for GlobalSearchFilters to control filter expansion
  const globalSearchFiltersRef = useRef();

  // Route detection for conditional global search visibility

  const location = useLocation();

  const isMainMapPage = location.pathname === "/" || location.pathname === "";

  const mapRef = useRef();
  const isProgrammaticMoveRef = useRef(false);
  const userOwnsCameraRef = useRef(false);

  const [isMapReady, setIsMapReady] = useState(false);

  const [bottomSheetOpen, setBottomSheetOpen] = useState(false);

  const [filterToggled, setFilterToggled] = useState(false);

  const filterButtonRef = useRef();



  const locationSearchRef = useRef();

  const locationSearchCompRef = useRef();

  const [locationSearchItems, setLocationSearchItems] = useState();

  const [locationSearchLoading, setLocationSearchLoading] = useState(0);

  const [locationSearchOpen, setLocationSearchOpen] = useState(false);

  const locationSearchTimer = useRef();

  const [locationResultsShowing, setLocationResultsShowing] = useState(false);



  const [smallIcon, setSmallIcon] = useState(false);

  const [searchFiltersExpanded, setSearchFiltersExpanded] = useState(false);

  const [searchFiltersHeight, setSearchFiltersHeight] = useState(0);

  const [bottomSheetExpanded, setBottomSheetExpanded] = useState(false);

  // State to track if we're currently in a filter animation (needs to be state to trigger re-renders)
  const [filterAnimating, setFilterAnimating] = useState(false);
  const animationTimeoutRef = useRef(null);

  // Handle height changes from GlobalSearchFilters
  const handleSearchFiltersHeightChange = useCallback((height) => {
    // Mark that we're animating
    setFilterAnimating(true);
    
    // Clear any existing timeout
    if (animationTimeoutRef.current) {
      clearTimeout(animationTimeoutRef.current);
    }
    
    // Mark animation as done after CSS transition completes
    animationTimeoutRef.current = setTimeout(() => {
      setFilterAnimating(false);
    }, 320); // 300ms CSS animation + 20ms buffer
    
    // Use functional update to get the latest state value
    setSearchFiltersHeight((prevHeight) => {
      // Only update if height actually changed significantly (prevent sub-pixel differences)
      const hasSignificantChange = Math.abs(prevHeight - height) >= 1;
      if (!hasSignificantChange) {
        return prevHeight; // Return previous value, no update
      }
      
      return height; // Return new height to update state
    });
  }, []);



  // Handle search filters expanded state change
  const handleSearchFiltersExpandedChange = (expanded) => {
    setSearchFiltersExpanded(expanded);
  };



  // Calculate dynamic CSS values based on search filters height

  const dynamicTopOffset = searchFiltersHeight > 0 

    ? `calc(var(--inyc-categories-bar-height) + ${searchFiltersHeight}px + 1rem)`

    : `var(--inyc-categories-bar-height)`;

    

  const dynamicMapHeight = 'calc(100vh - var(--inyc-categories-bar-height) - var(--inyc-bottom-navbar-height) - 30vh)'


  // Apply positioning to account for search bar

  useEffect(() => {

    // Only apply margin on mobile, not desktop
    if (!medium && bottomSheetRef?.current && searchFiltersHeight > 0) {

      if (bottomSheetExpanded) {

        // When bottom sheet is expanded, use full search filters height + extra margin for tab spacing

        const searchOnlyMargin = `${searchFiltersHeight + 10}px`; // +10px for the extra tab margin spacing

        // Disable transition during filter animation for instant tracking, but don't use !important to allow dragging class to override
        const transition = filterAnimating ? 'none' : 'margin-top 0.3s ease';
        bottomSheetRef.current.style.setProperty('transition', transition);

        bottomSheetRef.current.style.setProperty('margin-top', searchOnlyMargin, 'important');

        bottomSheetRef.current.style.setProperty('padding-top', '25px', 'important');

      } else {

        // When bottom sheet is collapsed, use minimal margin to hug the drag handle

        const collapsedSearchMargin = `${Math.min(searchFiltersHeight, 25)}px`; // Much smaller cap for tight spacing

        // Disable transition during filter animation for instant tracking, but don't use !important to allow dragging class to override
        const transition = filterAnimating ? 'none' : 'margin-top 0.3s ease';
        bottomSheetRef.current.style.setProperty('transition', transition);

        bottomSheetRef.current.style.setProperty('margin-top', collapsedSearchMargin, 'important');

        bottomSheetRef.current.style.setProperty('padding-top', '10px', 'important');

      }

    }

  }, [searchFiltersHeight, bottomSheetExpanded, medium, filterAnimating]); // Trigger on both height and expansion state changes



  useEffect(() => {

    if (!mapRef.current) return;



    const onZoomEnd = () => {

      const zoom = mapRef.current.getZoom();

      if (zoom > 13) {

        setSmallIcon(false);
        // console.log("zoomed in");
      } else {

        setSmallIcon(true);
        // console.log("zoomed out");
      }

    };

    const onUserCamera = () => {
      if (isProgrammaticMoveRef.current) return;
      userOwnsCameraRef.current = true;
    };

    mapRef.current.on("zoomend", onZoomEnd);
    mapRef.current.on("dragstart", onUserCamera);
    mapRef.current.on("zoomstart", onUserCamera);

    return () => {
      mapRef.current.off("zoomend", onZoomEnd);
      mapRef.current.off("dragstart", onUserCamera);
      mapRef.current.off("zoomstart", onUserCamera);
    };

  }, [mapRef.current]);



  useOutsideAlerter(filterButtonRef, () => {

    setFilterToggled(false);

  });

  const {

    // searchOpen: eventsOpen,

    setSearchOpen: setEventsOpen,

    setMainMapRef,

    registerResetMapViewport,

    bottomSheetRef,

    likedFilter,

    posterFilter,

    setLikedFilter,

    setPosterFilter,

    activeCategories,

    setActiveCategories,

    searchOpen,

    setSearchOpen,

    settingsOpen,

    setSettingsOpen,

    mainMapRef,

    darkMode,

  } = useUIContext();

  

  // Keep the desktop/tablet list search visible while settings are open;
  // phone layouts still hide it behind the settings panel.
  const shouldShowGlobalSearch = isMainMapPage && (medium || !settingsOpen);

  

  // Use setters hook for stable selectEvent and selectSubEvent functions
  const { selectEvent, selectSubEvent, 
    setSelectedEvent,
    setSelectedSubEvent,
    setDateFilter: setEventDetailsDateFilter,
    setQueryFilter: setEventDetailsQuery,
   } = useEventDetailsSetters();

  // Use ID-only hook for MapMarker selection (minimal re-renders)
  const { selectedEventId, selectedSubEventId } = useSelectedEventIds();
  
  // Only subscribe to full event objects on desktop where we need them for side panels
  // On mobile, these are handled by Protected.jsx bottom sheets
  // Using useContextSelector for granular subscription
  const selectedEvent = useContextSelector(
    EventDetailsContext, 
    state => medium ? state.selectedEvent : null
  );
  const selectedSubEvent = useContextSelector(
    EventDetailsContext,
    state => medium ? state.selectedSubEvent : null
  );

  const { selectedAccount, setSelectedAccount } = useAccountDetails();

  const {

    setMapPage,

    totalResults,

    refreshEvents,

    mapLocations,

    dateFilter,

    tagFilter,

    setTagFilter,

    searchQuery,

    setSearchQuery,

    activeTab,

    setActiveTab,

    mapLoading,

    setMapLoading,

    setDateFilter,

    mapPageLoading,

    mapResults,        // Grouped venue data for map pins

    searchResults,     // Flat event data for search/lists

    setSortMode,

    effectiveSortMode,

    defaultDateFilter,

  } = useMapContext();

  const hasActiveMobileFilterButtons = Array.isArray(tagFilter) && tagFilter.length > 0;
  const mobileSearchFiltersPaddingBottom =
    shouldShowGlobalSearch && (!searchFiltersExpanded || hasActiveMobileFilterButtons)
      ? "14px"
      : 0;


  const sortOptions = useMemo(() => {
    if (activeTab !== "event") return [];

    return [
      { label: "date", value: "date" },
      { label: "price: low to high", value: "price_asc" },
      { label: "price: high to low", value: "price_desc" },
      {
        label: "proximity",
        value: "proximity",
        disabled: !userLocation?.lat || !userLocation?.lng,
      },
      ...(searchQuery?.trim()
        ? [{ label: "relevance", value: "relevance" }]
        : []),
    ];
  }, [activeTab, searchQuery, userLocation?.lat, userLocation?.lng]);

  const currentSortOption = useMemo(
    () =>
      sortOptions.find((option) => option.value === effectiveSortMode) ||
      sortOptions[0],
    [sortOptions, effectiveSortMode]
  );

  const renderSortDropdown = () => {
    if (!currentSortOption) return null;

    return (
      <Dropdown
        variant="chip"
        aria-label="sort by"
        className="map-sort-dropdown"
        menuClassName="w-max"
        value={currentSortOption.value}
        options={sortOptions}
        onChange={(value) => setSortMode(value)}
      />
    );
  };

  // Memoized onClick handler for EventCard to prevent unnecessary re-renders
  const handleEventCardClick = useCallback((item) => {
    // CRITICAL: Only update the essential state immediately to trigger animation
    const matchingEvent = item._matchingEvent || (item.type === "venue" ? item.events?.[0] : null);
    if (matchingEvent) {
      selectEvent(item, { ...matchingEvent, _searchPageResult: true });
    } else if (item.venueDetails?._id || item.venue?._id) {
      selectEvent({ ...item, _searchPageResult: true });
    } else {
      selectEvent(item);
    }

    // DEFERRED: Update non-critical filters after animation completes (220ms)
    setTimeout(() => {
      setEventDetailsDateFilter(dateFilter);

      // Pass search query to venue details if there's an active search, otherwise clear it
      if (searchQuery && searchQuery.trim() !== "") {
        if (activeTab === 'event') {
          setEventDetailsQuery(searchQuery);
        } else if (activeTab === 'venue') {
          setEventDetailsQuery("");
        }
      } else {
        setEventDetailsQuery(null);
      }
    }, 220);

    // Frame the pin in the open map on every device (neighborhood zoom)
    if (mapRef.current) {
      fitMapToNeighborhood(mapRef.current, item, isProgrammaticMoveRef);
    }
  }, [
    selectEvent,
    setEventDetailsDateFilter,
    dateFilter,
    searchQuery,
    activeTab,
    setEventDetailsQuery,
    mapRef,
  ]);

  // Memoized onVenueClick handler for EventCard
  const handleVenueClick = useCallback((item) => {
    // CRITICAL: Only update the essential state immediately to trigger animation
    setSelectedEvent(item);

    // DEFERRED: Update non-critical filters after animation completes (220ms)
    setTimeout(() => {
      setEventDetailsDateFilter(dateFilter);

      // Pass search query to venue details if there's an active search, otherwise clear it
      if (searchQuery && searchQuery.trim() !== "") {
        if (activeTab === 'event') {
          setEventDetailsQuery(searchQuery);
        } else if (activeTab === 'venue') {
          setEventDetailsQuery("");
        }
      } else {
        setEventDetailsQuery(null);
      }
    }, 220);

    // Frame the pin in the open map on every device (neighborhood zoom)
    if (mapRef.current) {
      fitMapToNeighborhood(mapRef.current, item, isProgrammaticMoveRef);
    }
  }, [
    setSelectedEvent,
    setEventDetailsDateFilter,
    dateFilter,
    searchQuery,
    activeTab,
    setEventDetailsQuery,
    mapRef,
  ]);

  // Memoized getData function for InfiniteScroller to prevent unnecessary re-renders
  const handleGetData = useCallback(() => {
    setMapPage((prev) => ({
      page: prev.page + 1,
      limit: prev.limit,
    }));
  }, [setMapPage]);

const handleMarkerClick = useCallback((markerItem)=>{
  console.log("handleMarkerClick");

  // Enrich minified marker data with full event from searchResults (which has description etc.)
  let selectArg1 = markerItem;
  let selectArg2 = markerItem._matchingEvent
    ? { ...markerItem._matchingEvent, _mapMarker: true }
    : null;

  if (searchResults?.length) {
    if (markerItem._matchingEvent?._id) {
      // Venue marker: look up the matching event's full data so description is available
      const fullEvent = searchResults.find(r => r._id === markerItem._matchingEvent._id);
      if (fullEvent) {
        selectArg1 = fullEvent;
        selectArg2 = null; // selectEvent will extract venueDetails from fullEvent
      }
    } else if (!markerItem._matchingEvent) {
      // Pure event marker: look up full event data
      const fullEvent = searchResults.find(r => r._id === markerItem._id);
      if (fullEvent) {
        selectArg1 = fullEvent;
      }
    }
  }

  // CRITICAL: Only update the essential state immediately to trigger animation
  if (markerItem.events?.length > 1) {
    selectEvent(selectArg1);
  } else {
    selectEvent(selectArg1, selectArg2);
  }

  // DEFERRED: Update non-critical filters after animation completes (220ms)
  setTimeout(() => {
    setEventDetailsDateFilter(dateFilter);

    // Pass search query to venue details if there's an active search, otherwise clear it
    if (searchQuery && searchQuery.trim() !== "") {
      if (activeTab === 'event') {
        setEventDetailsQuery(searchQuery);
      } else if (activeTab === 'venue') {
        setEventDetailsQuery("");
      }
    } else {
      setEventDetailsQuery(null);
    }
  }, 220);

  if (mapRef.current) {
    fitMapToNeighborhood(mapRef.current, markerItem, isProgrammaticMoveRef);
  }
}, [searchResults, dateFilter, searchQuery, activeTab, setEventDetailsDateFilter, setEventDetailsQuery, selectEvent, mapRef]);

  // Memoized renderer function for InfiniteScroller to prevent unnecessary re-renders
  const renderItem = useCallback((item, i) => {
    if (activeTab === 'account' && (item.type === 'account' || item.username)) {
      return (
        <AccountCard
          key={i}
          data={item}
          className="map-event-container"
        />
      );
    }

    return (
      <div
        key={i}
        data-map-list-item=""
        data-map-list-index={i}
      >
        <EventCard
          className="map-event-container"
          fullWidth
          latestEvent={item?._matchingEvent}
          data={item}
          onClick={() => handleEventCardClick(item)}
          onVenueClick={() => handleVenueClick(item)}
          onEventClick={(ev) => {
            selectSubEvent(ev);
            if (mapRef.current) {
              fitMapToNeighborhood(mapRef.current, ev, isProgrammaticMoveRef);
            }
          }}
        />
      </div>
    );
  }, [
    activeTab,
    handleEventCardClick,
    handleVenueClick,
    selectSubEvent,
    mapRef,
  ]);

  // Search loading is now handled by MapContext



  // auto-expand/collapse bottom sheet based on active tab

  useEffect(() => {

    if (!bottomSheetRef || typeof bottomSheetRef.updateSheetHeight !== 'function') {

      return;

    }

    if (activeTab === 'event') {

      bottomSheetRef.updateSheetHeight(40);

      setBottomSheetExpanded(false);

    } else {

      bottomSheetRef.updateSheetHeight(100);

      setBottomSheetExpanded(true);

    }

  }, [activeTab, bottomSheetRef]);



  const eventRef = useRef();

  const subEventRef = useRef();

  

  // Handle suggestion interaction (moved from SearchContext)

  const handleSuggestionInteraction = (interacting) => {

    // This can be used for future suggestion interaction logic

    // For now, we'll keep it simple since it was just used for SearchContext

  };

  

  //#endregion



  //#region //^ ANALYTICS: track filter type

  const { trackSessionEvent } = useAnalytics();

  const initialFilterType = useRef(true);

  const initialCategories = useRef(true);

  const previousDateFilterRef = useRef(null);

  useEffect(() => {

    if (!initialFilterType.current) {
      // Deep equality check to prevent tracking identical filter changes
      // Compare the actual date values, not object references
      const current = dateFilter ? {
        start: dateFilter.start?.toISOString(),
        end: dateFilter.end?.toISOString()
      } : null;
      
      const previous = previousDateFilterRef.current;
      
      // Only track if the actual date values have changed
      const hasChanged = !previous || 
        current?.start !== previous?.start || 
        current?.end !== previous?.end;
      
      if (hasChanged) {
        trackSessionEvent({

          action: "filter changed",

          category: "filter",

          label: "filter_changed",

          value: {

            filterDate: dateFilter,

          },

          timestamp: Date.now(),

        });
        
        previousDateFilterRef.current = current;
      }

    } else {
      // Store initial value without tracking
      initialFilterType.current = false;
      previousDateFilterRef.current = dateFilter ? {
        start: dateFilter.start?.toISOString(),
        end: dateFilter.end?.toISOString()
      } : null;
    }

  }, [dateFilter]);



  useEffect(() => {

    if (!initialCategories.current) {

      trackSessionEvent({

        action: "categories changed",

        category: "filter",

        label: "categories_changed",

        value: activeCategories,

        timestamp: Date.now(),

      });

    }

    initialCategories.current = false;

  }, [activeCategories]);

  //#endregion

  const hasListScrolledRef = useRef(false);
  const awaitingOverviewFitRef = useRef(true);
  const hasCompletedInitialOverviewRef = useRef(false);
  const pendingTopResultFitRef = useRef(false);
  const sawFilterLoadingRef = useRef(false);
  const lastListFilterKeyRef = useRef(null);
  const sawMapLoadingRef = useRef(false);
  const lastFitLocationRef = useRef(null);
  const followItemIdRef = useRef(null);
  const listScrollRafRef = useRef(null);
  const mapResultsRef = useRef(mapResults);
  const mapLocationsRef = useRef(mapLocations);
  const userLocationRef = useRef(userLocation);
  const activeTabRef = useRef(activeTab);

  mapResultsRef.current = mapResults;
  mapLocationsRef.current = mapLocations;
  userLocationRef.current = userLocation;
  activeTabRef.current = activeTab;

  const locationKey = useCallback((loc) => {
    if (!loc?.lat || !loc?.lng) return "";
    return `${Number(loc.lat).toFixed(5)},${Number(loc.lng).toFixed(5)}`;
  }, []);

  const fitOverview = useCallback(() => {
    if (!mapRef.current || !userLocationRef.current) return;
    fitMapToOverview(
      mapRef.current,
      userLocationRef.current,
      mapResultsRef.current,
      isProgrammaticMoveRef
    );
    lastFitLocationRef.current = locationKey(userLocationRef.current);
    hasCompletedInitialOverviewRef.current = true;
  }, [locationKey]);

  const fitTopListResult = useCallback(() => {
    if (!mapRef.current) return false;
    const topItem = mapLocationsRef.current?.[0];
    if (!topItem) return false;
    const id = topItem._id || topItem.id || 0;
    followItemIdRef.current = id;
    hasListScrolledRef.current = false;
    fitMapToNeighborhood(mapRef.current, topItem, isProgrammaticMoveRef);
    return true;
  }, []);

  const resetMapToClosestVenues = useCallback(() => {
    userOwnsCameraRef.current = false;
    hasListScrolledRef.current = false;
    followItemIdRef.current = null;
    if (bottomSheetRef?.current) {
      bottomSheetRef.current.scrollTop = 0;
    }
    awaitingOverviewFitRef.current = true;
    if (!mapLoading && mapRef.current && userLocationRef.current) {
      fitOverview();
      awaitingOverviewFitRef.current = false;
    }
  }, [bottomSheetRef, mapLoading, fitOverview]);

  const handleListScroll = useCallback(() => {
    if (userOwnsCameraRef.current) return;
    if (activeTabRef.current !== "event") return;
    const root = bottomSheetRef?.current;
    if (!root || !mapRef.current) return;

    if (root.scrollTop <= LIST_SCROLL_TOP_THRESHOLD) {
      if (hasListScrolledRef.current) {
        hasListScrolledRef.current = false;
        followItemIdRef.current = null;
        fitOverview();
      }
      return;
    }

    hasListScrolledRef.current = true;
    const items = root.querySelectorAll("[data-map-list-item]");
    const lead = findFirstFullyVisibleListItem(
      root,
      items,
      getListStickyOffset(root)
    );
    if (!lead) return;

    const item = mapLocationsRef.current?.[lead.index];
    if (!item) return;
    const id = item._id || item.id || lead.index;
    if (followItemIdRef.current === id) return;
    followItemIdRef.current = id;
    fitMapToNeighborhood(mapRef.current, item, isProgrammaticMoveRef);
  }, [bottomSheetRef, fitOverview]);

  // Memoize user location marker position and icon to prevent unnecessary re-renders
  const userMarkerPosition = useMemo(() => {
    if (!userLocation?.lat || !userLocation?.lng) return null;
    return [userLocation.lat, userLocation.lng];
  }, [userLocation?.lat, userLocation?.lng]);

  const userMarkerIcon = useMemo(() => createUserIcon(), []);

  // Memoize MapContainer props to prevent unnecessary re-renders
  const mapContainerStyle = useMemo(() => ({
    '--dynamic-map-height': dynamicMapHeight
  }), [dynamicMapHeight]);

  const mapCenter = useMemo(() => 
    [userLocation.lat, userLocation.lng],
    [userLocation.lat, userLocation.lng]
  );

  const mapMaxBounds = useMemo(() => [
    [-90, -180],
    [90, 180],
  ], []);

  const handleMapReady = useCallback((map) => {
    mapRef.current = map.target;
    setMainMapRef(map.target);
    // Only invalidate size for proper map initialization
    setTimeout(() => {
      map.target.invalidateSize();
      setIsMapReady(true);
    }, 200);
  }, [setMainMapRef]);

  //#region effects

  useEffect(() => {
    if (registerResetMapViewport) {
      registerResetMapViewport(resetMapToClosestVenues);
    }
    return () => {
      registerResetMapViewport?.(null);
    };
  }, [registerResetMapViewport, resetMapToClosestVenues]);

  useEffect(() => {
    if (mapLoading) {
      sawMapLoadingRef.current = true;
      hasListScrolledRef.current = false;
      followItemIdRef.current = null;
    }
  }, [mapLoading]);

  useEffect(() => {
    const key = locationKey(userLocation);
    if (!key || key === lastFitLocationRef.current) return;
    // The overview fit below only runs on the events tab; elsewhere just follow the new location.
    if (activeTabRef.current !== "event") {
      if (flyMapToLocation(mapRef.current, userLocation, isProgrammaticMoveRef)) {
        lastFitLocationRef.current = key;
      }
      return;
    }
    if (userOwnsCameraRef.current || hasListScrolledRef.current) return;
    awaitingOverviewFitRef.current = true;
  }, [userLocation?.lat, userLocation?.lng, locationKey]);

  useEffect(() => {
    if (!awaitingOverviewFitRef.current) return;
    if (pendingTopResultFitRef.current) return;
    if (userOwnsCameraRef.current || hasListScrolledRef.current) return;
    if (!isMapReady || !mapRef.current || !userLocation?.lat || !userLocation?.lng) return;
    if (activeTab !== "event") return;
    if (mapLoading || !sawMapLoadingRef.current) return;

    fitOverview();
    awaitingOverviewFitRef.current = false;
  }, [isMapReady, mapLoading, mapResults, userLocation, activeTab, fitOverview]);

  useEffect(() => {
    if (medium) return;
    if (userOwnsCameraRef.current || hasListScrolledRef.current) return;
    if (!isMapReady || !mapRef.current) return;
    if (activeTab !== "event") return;
    if (mapLoading || !hasCompletedInitialOverviewRef.current) return;

    const map = mapRef.current;
    const timer = window.setTimeout(() => {
      map.invalidateSize();
      if (userOwnsCameraRef.current || hasListScrolledRef.current) return;
      fitOverview();
    }, 280);

    return () => window.clearTimeout(timer);
  }, [
    medium,
    bottomSheetExpanded,
    isMapReady,
    mapLoading,
    activeTab,
    fitOverview,
  ]);

  useEffect(() => {
    const key = JSON.stringify({
      start: dateFilter?.start?.toISOString?.() || dateFilter?.start || null,
      end: dateFilter?.end?.toISOString?.() || dateFilter?.end || null,
      tags: tagFilter || [],
      sort: effectiveSortMode || null,
    });

    if (lastListFilterKeyRef.current === null) {
      lastListFilterKeyRef.current = key;
      return;
    }
    if (lastListFilterKeyRef.current === key) return;
    lastListFilterKeyRef.current = key;
    if (!hasCompletedInitialOverviewRef.current) return;
    if (activeTab !== "event") return;

    pendingTopResultFitRef.current = true;
    sawFilterLoadingRef.current = false;
    awaitingOverviewFitRef.current = false;
    userOwnsCameraRef.current = false;
    hasListScrolledRef.current = false;
    followItemIdRef.current = null;
    if (bottomSheetRef?.current) {
      bottomSheetRef.current.scrollTop = 0;
    }
  }, [dateFilter, tagFilter, effectiveSortMode, activeTab, bottomSheetRef]);

  useEffect(() => {
    if (!pendingTopResultFitRef.current) return;
    if (mapLoading) {
      sawFilterLoadingRef.current = true;
      return;
    }
    if (!sawFilterLoadingRef.current) return;
    if (!isMapReady || !mapRef.current) return;
    if (activeTab !== "event") return;

    if (mapLocations?.length) {
      fitTopListResult();
    }
    pendingTopResultFitRef.current = false;
    sawFilterLoadingRef.current = false;
  }, [isMapReady, mapLoading, mapLocations, activeTab, fitTopListResult]);

  useEffect(() => {
    const root = bottomSheetRef?.current;
    if (!root) return;

    const onScroll = () => {
      if (listScrollRafRef.current) return;
      listScrollRafRef.current = requestAnimationFrame(() => {
        listScrollRafRef.current = null;
        handleListScroll();
      });
    };

    root.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      root.removeEventListener("scroll", onScroll);
      if (listScrollRafRef.current) {
        cancelAnimationFrame(listScrollRafRef.current);
        listScrollRafRef.current = null;
      }
    };
  }, [bottomSheetRef, handleListScroll]);



  //add --inyc-page-top-space : 3.5rem to body to match compact categories bar height

  useEffect(() => {

    document.body.style.setProperty("--inyc-page-top-space", `3.5rem`);



    return () => {

      // set it to 0rem

      document.body.style.setProperty("--inyc-page-top-space", "0px");

    };

  }, []);

  //#endregion



  //#region handlers



  const onLocationChange = async (e) => {

    //add to search queue

    // console.log("location chaged ,", e);

    if (!e?.target?.value) {
      clearTimeout(locationSearchTimer.current);
      setLocationSearchItems();
      setLocationSearchLoading(false);
      return;
    }

    setLocationSearchLoading(true);

    clearTimeout(locationSearchTimer.current);

    locationSearchTimer.current = setTimeout(async () => {

      const autocompleteUrl = `${backendUrl}/influencer/geolocation/autocomplete?${new URLSearchParams(

        {

          input: e?.target.value,

        }

      )}`;



      try {

        const results = await axiosInstance.get(autocompleteUrl);

        // console.log(results?.data);

        if (results.status === 200) {

          setLocationSearchItems(results.data);

        }



        // console.log(results);

      } catch (error) {

        console.log("Axios Error", error);

      } finally {

        setLocationSearchLoading(false);

      }

    }, 1000);

  };



  const selectLocationSuggestion = async (sug) => {

    try {

      setLocationSearchLoading(true);

      try {

        const { data } = await axiosInstance.get(

          `${backendUrl}/influencer/geolocation/place?${new URLSearchParams({

            place_id: sug?.place_id,

          })}`

        );



        const latitude = data.geometry?.location?.lat; // Latitude

        const longitude = data.geometry?.location?.lng;



        // Set the marker

        if (latitude && longitude) {

          // locationSearchCompRef?.current?.close()

          setUserLocation({ lat: latitude, lng: longitude });

          setLocationSearchOpen(false);

        }

      } catch (error) {

        console.log(error);

      } finally {

        setLocationSearchLoading(false);

      }

    } catch (error) {

      console.log(error);

    }

  };



  const onGetDirections = () => {

    const coordinates = getMapItemCoordinates(selectedEvent);
    if (!coordinates) return;

    openDirections(coordinates);

  };



  const handleMapTagClick = (e) => {

    // handle all tag

    if (e.currentTarget.id === "all") {

      if (activeCategories.length === categories.length) {

        setActiveCategories([]);

      } else {

        setActiveCategories(categories.map((cat) => cat.id));

      }

      return;

    }



    // NEW LOGIC: If all categories are selected and a category is clicked, select only that category

    if (activeCategories.length === categories.length) {

      setActiveCategories([e.currentTarget.id]);

      return;

    }



    // if activeCategories includes the tag id, remove it

    if (activeCategories.includes(e.currentTarget.id)) {

      setActiveCategories((prev) =>

        prev.filter((item) => item !== e.currentTarget.id)

      );

    } else {

      setActiveCategories((prev) => [...prev, e.currentTarget.id]);

    }

  };



  const onCalendarIconClick = () => {

    bottomSheetRef && !medium && bottomSheetRef.updateSheetHeight(100);

  };



  //#endregion






  // console.log("tagFilter ", tagFilter);

  const locationPromptOpen =

    distance(

      userLocation?.lat,

      userLocation?.lng,

      newYorkCoords.lat,

      newYorkCoords.lng

    ) > 150;



  useEffect(() => {
    // console.log("mapLoading ", mapLoading);
  }, [mapLoading]);



  return (

    <div className="main-container flex">

      <div>

        {/* //* ======================= BOTTOM SHEET ======================= */}

        <BottomSheet

          onHeightChange={(height) => {

            if (height === 100) {

              setBottomSheetOpen(true);

              setBottomSheetExpanded(true);

            } else {

              setBottomSheetOpen(false);

              setBottomSheetExpanded(false);

            }

          }}

          useAsBottomSheetRef

          defaultHeight={activeTab === 'event' ? 40 : 100}

          draggable={activeTab === 'event'}

          showDismiss={activeTab === 'event'}

          className="md:!left-[--inyc-side-bar-width] !shadow-none dynamic-bottom-sheet"

          contentClassName="map-bottom-sheet-content md:!mt-kit-16"

          dateFilter={dateFilter}

          searchQuery={searchQuery}

          searchFiltersHeight={searchFiltersHeight}

          bottomSheetExpanded={bottomSheetExpanded}

          filterAnimating={filterAnimating}

          datePickerRef={listPanelDatePickerRef}

          globalSearchFiltersRef={globalSearchFiltersRef}

          headerLeft={!medium && activeTab === 'event' ? renderSortDropdown() : null}

          style={{

            '--dynamic-top-offset': dynamicTopOffset,

            marginTop: dynamicTopOffset // Direct style as fallback

          }}

        >

          {/* OLD FILTERS - COMMENTED OUT TEMPORARILY - moved to top bar */}

          {/* 

          <BottomSheetDateFilter

            defaultDate={defaultDateFilter}

            tagFilter={tagFilter}

            className="!pt-kit-32"

            setTagFilter={setTagFilter}

            onCalendarIconClick={onCalendarIconClick}

            setFilterDate={setDateFilter}

            filterDate={dateFilter}

            showCalendar={false}

            knownServices={knownServices}

            mapRef={mapRef}

            style={{

              zIndex: 100,

            }}

          />

          */}

          

          <div

            style={{

              paddingBottom: "var(--inyc-space-48)",

              marginTop: "-2rem",

              backgroundColor: "var(--inyc-primary)",

            }}

          >

            {medium && (
              <div className="map-list-desktop-sticky-controls">
                <div className="map-list-search-row mb-0 pl-kit-10 pr-kit-16 pb-0 transition-all duration-300 ease-in-out">

                <GlobalSearchFilters

                  ref={globalSearchFiltersRef}

                  // Search configuration

                  searchValue={searchQuery}

                  onSearchChange={(e) => setSearchQuery(e.target.value)}

                  searchPlaceholder="search genre, sub-genre, venue, etc."

                  isVisible={shouldShowGlobalSearch}

                  // Tabs configuration - show events/venues/accounts on main map

                  showSearchTabs={true}

                  tabs={[

                    { label: "events", value: "event" },

                    { label: "venues", value: "venue" },

                    { label: "accounts", value: "account" },

                  ]}

                  activeTab={activeTab}

                  onTabChange={setActiveTab}

                  // Tab-specific filter configuration

                  tabFilterConfig={{

                    event: {

                      showDateFilter: true,

                      showTags: true,

                      customFilters: []

                    },

                    venue: {

                      showDateFilter: false,

                      showTags: false,

                      customFilters: [

                        {

                          id: "venue-filters",

                          render: () => (

                            <div className="venue-specific-filters"></div>

                          )

                        }

                      ]

                    },

                    account: {

                      showDateFilter: false,

                      showTags: false,

                      customFilters: [

                        {

                          id: "account-filters",

                          render: () => (

                            <div className="account-specific-filters"></div>

                          )

                        }

                      ]

                    }

                  }}

                  

                  // Date filter configuration (fallback)

                  showDateFilter={true}

                  dateFilter={dateFilter}

                  onDateFilterChange={setDateFilter}

                  defaultDateFilter={defaultDateFilter}

                  datePickerRef={listPanelDatePickerRef}

                  

                  // Tags configuration (fallback)

                  showTags={true}

                  knownServices={knownServices}

                  activeTags={tagFilter || []}

                  onTagToggle={(tagId) => {
                    const service = knownServices[tagId];
                    console.log("Tag clicked:", tagId, "Service:", service);
                    
                    if (tagFilter?.includes(tagId)) {
                      // Removing tag - clear all tags (single selection)
                      setTagFilter([]);
                      // Reset date filter back to default if the removed tag had a forced date range
                      if (service?.dateRange && defaultDateFilter) {
                        console.log("Resetting dateFilter to default:", defaultDateFilter);
                        setDateFilter(defaultDateFilter);
                      }
                    } else {
                      // Adding tag - replace all other tags with this one (single selection)
                      setTagFilter([tagId]);
                      
                      // Auto-apply date range if service has one and we're using default filter
                      if (service?.dateRange) {
                        console.log("Service has dateRange:", service.dateRange);
                        if (isDefaultDateFilter(dateFilter)) {
                          console.log("Current dateFilter is default, applying service dateRange");
                          // Convert from service timezone to local timezone
                          const serviceTimezone = service.dateRange.timezone || 'UTC';
                          
                          const startDate = DateTime.fromISO(service.dateRange.start, { zone: serviceTimezone })
                            .setZone('local')
                            .toJSDate();
                          const endDate = DateTime.fromISO(service.dateRange.end, { zone: serviceTimezone })
                            .setZone('local')
                            .toJSDate();
                          
                          console.log("Setting dateFilter to:", { start: startDate, end: endDate });
                          setDateFilter({ start: startDate, end: endDate });
                        } else {
                          console.log("Current dateFilter is NOT default, not applying service dateRange");
                        }
                      } else {
                        console.log("Service does not have a dateRange");
                      }

                      // Auto-move map if service has a location
                      if (service?.location) {
                        console.log("Service has location:", service.location);
                        if (mapRef.current) {
                          console.log("Moving map to location:", [service.location.lat, service.location.lng]);
                          mapRef.current.flyTo([service.location.lat, service.location.lng], 13);
                        } else {
                          console.log("mapRef.current is null");
                        }
                      } else {
                        console.log("Service does not have a location");
                      }
                    }
                  }}

                  

                  // Loading states

                  searchLoading={mapPageLoading}

                  

                  // Auto suggestions disabled

                  autoSuggestions={[]}

                  

                  // no dynamic height callbacks on desktop

                  className="list-panel-global-search-filters mt-kit-12"
                  allowOverflow

                />

                </div>
              {/* Date Filter Indicator for Desktop */}
              {activeTab === 'event' && (
                <div className="map-list-meta-row mt-kit-2 md:mt-kit-8 !mb-kit-2 z-[300] px-kit-8">
                  {renderSortDropdown()}
                      <DateFilterIndicator 
                        dateFilter={dateFilter}
                        searchQuery={searchQuery}
                        className="!mb-0"
                        onClick={() => {
                          console.log('Desktop DateFilterIndicator onClick fired', {
                            hasRef: !!listPanelDatePickerRef.current,
                            hasFiltersRef: !!globalSearchFiltersRef.current,
                          });
                          
                          // First, expand the filters
                          if (globalSearchFiltersRef.current) {
                            globalSearchFiltersRef.current.expandFilters();
                          }
                          
                          // Then open the calendar after a small delay to ensure filters are expanded
                          if (listPanelDatePickerRef.current) {
                            setTimeout(() => {
                              listPanelDatePickerRef.current.openCalendar();
                            }, 100);
                          }
                        }}
                      />
                </div>
              )}
              </div>
            )}

            {mapLoading ? (

              <div className="flex justify-center items-center w-full h-[100px]">

                <Loader />

              </div>

            ) : (

              mapLocations && (

                <PullToActionWrapper

                    className={"pb-[5rem] relative"}

                    containerRef={bottomSheetRef}

                    onPull={async () => {

                      setMapLoading(true);



                      try {

                        const coords = await getCurrentLocation({

                          setLocation: setUserLocation,

                          options: {

                            timeout: 10000,

                            maximumAge: 0,

                          },

                        });

                        //reload events

                        if (coords && coords.latitude) {

                          refreshEvents();

                          resetMapToClosestVenues();

                        } else if (userLocation?.lat && userLocation?.lng) {

                          refreshEvents();

                          resetMapToClosestVenues();

                        } else {

                          // No valid location available, turn off loading

                          mapDebugLogger.log("No valid location available for refresh");

                          setMapLoading(false);

                        }

                      } catch (error) {

                        // If geolocation fails, still refresh with current location

                        mapDebugLogger.log("Geolocation failed, refreshing with current location:", error);

                        if (userLocation?.lat && userLocation?.lng) {

                          refreshEvents();

                          resetMapToClosestVenues();

                        } else {

                          // No valid location available, turn off loading

                          mapDebugLogger.log("No valid location available for refresh");

                          setMapLoading(false);

                        }

                      }

                      // Don't set loading to false here - refreshEvents handles it



                    }}

                  >

                    

                    {mapLocations.length === 0 ? (

                      <div className="map-events-none mt-kit-32">

                        {likedFilter

                          ? 'you have not favorited any events or venues.'

                          : (() => {
                              switch(activeTab) {
                                case 'venue':
                                  return 'no venues found. try adjusting your search or location.';
                                case 'account':
                                  return (
                                    <>
                                      no accounts found
                                      <br />
                                      adjust search query
                                    </>
                                  );
                                case 'event':
                                default:
                                  return 'no results match. try adjusting the categories, dates, or times.';
                              }
                            })()}

                      </div>

                    ) : (

                      <InfiniteScroller
                        className={
                          activeTab === "event"
                            ? "pt-kit-8 md:pt-kit-12"
                            : "-mt-[8px] pt-0 md:mt-0 md:pt-kit-12"
                        }
                        getData={handleGetData}
                      loading={mapPageLoading}
                      hasMore={mapLocations?.length < totalResults}
                      items={mapLocations}
                        renderer={renderItem}

                    />

                    )}

                  </PullToActionWrapper>

              )

            )}

          </div>

          {/* </div> */}

        </BottomSheet>



        {/* //* ====================== EVENT DETAILS ====================== */}

        {medium && (

          <>

            <div

              ref={eventRef}

              className={`map-event-details-container duration-300 ${

                !selectedEvent ? "translate-x-[-100%]" : "translate-x-[0]"

              }`}

            >

              {selectedEvent && (

                <>

                  <EventDetails

                    className="!pt-kit-32"

                    parentRef={eventRef}

                    useAsAnalytics

                    userLocation={userLocation}

                    Close={() => {

                      setSelectedEvent(null);

                    }}

                    refreshEvents={refreshEvents}

                    data={selectedEvent}

                    onGetDirections={onGetDirections}

                    onSelectEvent={(event) => {

                      selectSubEvent(event);

                      setEventDetailsDateFilter(dateFilter);

                    }}

                  />

                </>

              )}

            </div>

            <div

              ref={subEventRef}

              className={`map-sub-event-details-container duration-300 ${

                !selectedSubEvent ? "translate-x-[-100%]" : "translate-x-[0]"

              }`}

            >

              {selectedSubEvent && (

                <>

                  <EventDetails

                    className="!pt-kit-32"

                    parentRef={subEventRef}

                    useAsAnalytics

                    userLocation={userLocation}

                    Close={() => {

                      setSelectedSubEvent(null);

                      if (
                        selectedEvent?.events?.length <= 1 ||
                        selectedSubEvent?._searchPageResult ||
                        selectedSubEvent?._mapMarker
                      ) {

                        setSelectedEvent(null);

                      }

                    }}

                    refreshEvents={refreshEvents}

                    data={selectedSubEvent}

                    onGetDirections={onGetDirections}

                  />

                </>

              )}

            </div>

            <div

              className={`map-account-details-container duration-300 ${

                !selectedAccount ? "translate-x-[-100%]" : "translate-x-[0]"

              }`}

            >

              <AccountDetails />

            </div>

          </>

        )}

      </div>

      <div className="w-full md:w-[calc(100%-max(30vw,500px))] ml-auto">

        {/* //*=============================LOCATION PROMPTS============================= */}

        {locationPromptOpen && (

          <div

            style={{

              position: "absolute",

              width: "100vw",

              height:

                "calc(100vh - calc(var(--inyc-categories-bar-height) + calc(var(--inyc-bottom-space) + var(--inyc-bottom-navbar-height))))",

              display: "flex",

              justifyContent: "center",

              alignItems: "center",

              background: "rgba(0,0,0,0.7)",

              zIndex: "2004",

              // paddingBottom: "7rem",

              pointerEvents: "all",

            }}

            className="location-prompt"

          >

            <div

              className="text-center flex flex-col items-center justify-center aspect-square"

              style={{

                padding: "var(--inyc-space-24) var(--inyc-space-20)",

                background: "var(--inyc-primary)",

                borderRadius: "var(--inyc-radius-lg)",

                width: "min(90%, 400px)",

                pointerEvents: "all",

              }}

            >

              <div className="font-['Primary-Regular'] text-kit-xl leading-[1.45] tracking-[-0.02em] text-[var(--inyc-primary-text-color-light)]">

                <span className="font-['Primary-Regular'] font-normal">we aren't </span>

                <span className="font-['Primary-Bold'] font-bold">in</span>

                <span className="font-['Primary-Regular'] font-normal">—</span>

                <span className="font-['Primary-Bold'] font-bold">y</span>

                <span className="font-['Primary-Regular'] font-normal">our—</span>

                <span className="font-['Primary-Bold'] font-bold">c</span>

                <span className="font-['Primary-Regular'] font-normal">ity </span>

                <i className="font-['Primary-Regular'] font-normal">yet</i>

              </div>

              <div className="mt-kit-16 flex items-center justify-center gap-kit-16">

                {getCategoryPalette(categories).slice(0, 5).map((category, index) => (

                  <span

                    key={`${category.activeColor}-${index}`}

                    className="h-[1.05rem] w-[1.05rem] rounded-kit-full"

                    style={{ backgroundColor: category.activeColor }}

                  />

                ))}

              </div>

              <div className="mt-kit-24 flex justify-center">

                <KitButton
                  variant="primary"
                  onClick={() => {
                    setUserLocation(newYorkCoords);
                    mapRef.current.flyTo(newYorkCoords);
                  }}
                >
                  take me to new york city
                </KitButton>

              </div>

            </div>

          </div>

        )}

        {/* //* ====================== SIDEBAR_BUTTON ====================== */}

        <div

          className={`map-options-flex pointer-events-none w-[calc(100%-2rem)] 

            md:w-fit md:right-[1rem] md:!items-end

            md:flex-col  !justify-between duration-300 !z-[2004]

          ${

            searchOpen || bottomSheetOpen || locationPromptOpen

              ? "translate-y-[calc(calc(max(40vh,200px)+1rem)-calc(1rem+var(--inyc-bottom-navbar-height)))] sm:translate-y-0"

              : "translate-x-0"

          }

          `}

        >

          <div

            className={`map-options-item pointer-events-auto !rounded-kit-full md:order-[3] ${

              locationSearchOpen

                ? `md:!w-[500px] !w-[300px] ${

                    locationResultsShowing

                      ? "!rounded-b-kit-2xl !rounded-t-none "

                      : ""

                  }`

                : "!w-[2.5rem] !p-0"

            } duration-300 cursor-default flex items-center ${
              locationSearchOpen ? "!justify-start" : "!justify-center"
            } relative`}

          >

            <div

              onClick={() => {

                setLocationSearchOpen((prev) => !prev);

                locationSearchCompRef?.current?.open();

              }}

              className={`cursor-pointer flex items-center justify-center ${
                locationSearchOpen
                  ? "max-w-[1.5rem] min-w-[1.5rem]"
                  : "w-[17px] min-w-[17px]"
              }`}

            >

              <FiNavigation
                className="map-location-arrow-icon"
                size={17}
                strokeWidth={1.5}
              />

              {/* <LocationSVG /> */}

            </div>

            <div className={`min-w-0 cursor-default ${
              locationSearchOpen
                ? "w-full ml-kit-16"
                : "w-0 ml-0 overflow-hidden opacity-0 pointer-events-none"
            }`}>

              <DropDownInput

                noWrapperStyle

                open={locationSearchOpen}

                dropDownClassName="!w-[calc(100%+1.65rem)] max-h-[calc(100svh-calc(40vh+calc(var(--inyc-bottom-space)+calc(var(--inyc-categories-bar-height)+5.5rem))))] mr-kit-40 p-kit-16 !rounded-t-kit-2xl translate-y-[5px]"

                dropDownDirection="top"

                style={{

                  width: "100%",

                  cursor: "default",

                  height: "3rem",

                  marginTop: 0,

                  padding: 0,

                  borderRadius: 0,

                  borderColor: "rgba(0,0,0,0)",

                  borderBottomColor: "var(--inyc-divider)",

                }}

                ItemComponent={({ item, key }) => {

                  const suggestion = item;

                  // console.log(suggestion);

                  if (!suggestion) return null;

                  let mainText, secondaryText, matchStart, matchEnd;



                  mainText = suggestion.structured_formatting.main_text;

                  secondaryText =

                    suggestion.structured_formatting.secondary_text;

                  matchStart =

                    suggestion.structured_formatting

                      ?.main_text_matched_substrings?.[0]?.offset || 0;

                  matchEnd =

                    matchStart +

                      suggestion.structured_formatting

                        ?.main_text_matched_substrings?.[0]?.length ||

                    mainText?.length ||

                    0;



                  // Construct suggestion display

                  const display = (

                    <>

                      {mainText.slice(0, matchStart)?.toLowerCase()}

                      <strong>

                        {mainText.slice(matchStart, matchEnd)?.toLowerCase()}

                      </strong>

                      {mainText.slice(matchEnd)?.toLowerCase()}

                      <br />

                      {secondaryText && (

                        <div className="text-gray-500 max-w-full overflow-hidden overflow-ellipsis">

                          {secondaryText?.toLowerCase()}

                        </div>

                      )}

                    </>

                  );



                  return (

                    <div

                      key={key}

                      onClick={() => {

                        selectLocationSuggestion(suggestion);

                      }}

                      className="cursor-pointer duration-300 hover:bg-hover relative text-kit-xs p-kit-16 rounded-kit-sm"

                    >

                      {display}

                    </div>

                  );

                }}

                dropItems={locationSearchItems?.filter((l) => !l._id)}

                placeHolder="search a location"

                clearable={locationSearchOpen}
                clearLabel="clear location"

                onClearEmpty={() => {
                  setLocationSearchOpen(false);
                  setLocationResultsShowing(false);
                  locationSearchCompRef.current?.close();
                  locationSearchRef.current?.blur();
                }}

                onChange={onLocationChange}

                Ref={locationSearchRef}

                ref={locationSearchCompRef}

                onFocusChange={(e, f) => {

                  // console.log("map", e, f);

                  if (locationSearchRef?.current?.value === "" && !e && !f) {

                    setLocationSearchOpen(false);

                  }

                  setLocationResultsShowing(e);

                }}

                dropLoading={locationSearchLoading}

              />

            </div>

          </div>

          <div className="flex pointer-events-auto gap-kit-16 md:flex-col">

            <div

              className="map-options-item pointer-events-auto"

              onClick={() => setLikedFilter((prev) => !prev)}

            >

              {likedFilter ? (

                <FiHeart
                  className="map-options-icon"
                  size={17}
                  color="var(--inyc-secondary)"
                  fill="currentColor"
                />

              ) : (

                <FiHeart
                  className="map-options-icon"
                  size={17}
                />

              )}

            </div>

          </div>

        </div>



        {/* //* ====================== TOP BAR - CATEGORIES & SEARCH ====================== */}

        <div id="map-top-bar" className={`w-full fixed top-0 left-0 z-[20004] bg-[var(--inyc-primary)] border-b border-[var(--inyc-border-color)] ${bottomSheetExpanded ? 'bottom-sheet-expanded' : ''}`}>

          {/* Logo and Categories Row */}

          <div className="flex justify-start w-full max-w-[100vw] overflow-hidden min-h-[--inyc-categories-bar-height] max-h-[--inyc-categories-bar-height]">

            <div className="flex min-h-full justify-start md:justify-between items-center overflow-x-auto overflow-y-hidden px-kit-16 w-full">

            <div

              onClick={() => {

                setSearchOpen(false);

                setSettingsOpen(false);

                // Reset tab to events when clicking logo
                setActiveTab('event');

                if (bottomSheetRef) {

                  bottomSheetRef.updateSheetHeight(30);

                  bottomSheetRef.current.scrollTop = 0;

                }

                resetMapToClosestVenues();

              }}

              className="min-w-[100px] max-w-[150px]"

            >

              <Logo src={logoStatic} style={{ padding: "var(--inyc-space-6)" }} />

            </div>

            <div className="flex justify-start items-center gap-kit-8">

                            <Chip
                size="lg"
                selected={activeCategories.length === categories.length}
                id="all"
                onClick={handleMapTagClick}
              >
                all
              </Chip>

              {categories.map((category, i) => (

                <Chip
                  key={i}
                  size="lg"
                  color={category.activeColor}
                  selected={activeCategories.includes(category.id)}
                  id={category.id}
                  onClick={handleMapTagClick}
                >
                  {category.id}
                </Chip>

              ))}

            </div>

            </div>

          </div>

          

          {/* Global Search Filters Row - mobile only */}

          {!medium && (

          <div
            className="px-kit-16 transition-all duration-300 ease-in-out"
            style={{
              backgroundColor: "var(--inyc-primary)",
              paddingBottom: mobileSearchFiltersPaddingBottom,
            }}
          >

            <GlobalSearchFilters

              ref={globalSearchFiltersRef}

              // Search configuration

              searchValue={searchQuery}

              onSearchChange={(e) => setSearchQuery(e.target.value)}

              searchPlaceholder="search genre, sub-genre, venue, etc."

              isVisible={shouldShowGlobalSearch}

              // Tabs configuration - show events/venues/accounts on main map

              showSearchTabs={true}

              tabs={[

                { label: "events", value: "event" },

                { label: "venues", value: "venue" },

                { label: "accounts", value: "account" },

              ]}

              activeTab={activeTab}

              onTabChange={setActiveTab}

              // Tab-specific filter configuration

              tabFilterConfig={{

                event: {

                  showDateFilter: true,

                  showTags: true,

                  customFilters: []

                },

                venue: {

                  showDateFilter: false,

                  showTags: false,

                  customFilters: [

                    {

                      id: "venue-filters",

                      render: () => (

                        <div className="venue-specific-filters">

                          {/* Future: Add venue-specific filters like cuisine type, price range, etc. */}

                        </div>

                      )

                    }

                  ]

                },

                account: {

                  showDateFilter: false,

                  showTags: false,

                  customFilters: [

                    {

                      id: "account-filters",

                      render: () => (

                        <div className="account-specific-filters">

                          {/* Future: Add account-specific filters like follower count, verification status, etc. */}

                        </div>

                      )

                    }

                  ]

                }

              }}

              

              // Date filter configuration (fallback)

              showDateFilter={true}

              dateFilter={dateFilter}

              onDateFilterChange={setDateFilter}

              defaultDateFilter={defaultDateFilter}

              datePickerRef={listPanelDatePickerRef}

              

              // Tags configuration (fallback)

              showTags={true}

              knownServices={knownServices}

              activeTags={tagFilter || []}

              onTagToggle={(tagId) => {
                const service = knownServices[tagId];
                console.log("Mobile tag clicked:", tagId, "Service:", service);
                
                if (tagFilter?.includes(tagId)) {
                  // Removing tag - clear all tags (single selection)
                  setTagFilter([]);
                  // Reset date filter back to default if the removed tag had a forced date range
                  if (service?.dateRange && defaultDateFilter) {
                    console.log("Mobile resetting dateFilter to default:", defaultDateFilter);
                    setDateFilter(defaultDateFilter);
                  }
                } else {
                  // Adding tag - replace all other tags with this one (single selection)
                  setTagFilter([tagId]);
                  
                  // Auto-apply date range if service has one and we're using default filter
                  if (service?.dateRange) {
                    console.log("Mobile service has dateRange:", service.dateRange);
                    if (isDefaultDateFilter(dateFilter)) {
                      console.log("Mobile current dateFilter is default, applying service dateRange");
                      // Convert from service timezone to local timezone
                      const serviceTimezone = service.dateRange.timezone || 'UTC';
                      
                      const startDate = DateTime.fromISO(service.dateRange.start, { zone: serviceTimezone })
                        .setZone('local')
                        .toJSDate();
                      const endDate = DateTime.fromISO(service.dateRange.end, { zone: serviceTimezone })
                        .setZone('local')
                        .toJSDate();
                      
                      console.log("Mobile setting dateFilter to:", { start: startDate, end: endDate });
                      setDateFilter({ start: startDate, end: endDate });
                    } else {
                      console.log("Mobile current dateFilter is NOT default, not applying service dateRange");
                    }
                  } else {
                    console.log("Mobile service does not have a dateRange");
                  }

                  // Auto-move map if service has a location
                  if (service?.location) {
                    console.log("Mobile service has location:", service.location);
                    if (mapRef.current) {
                      console.log("Mobile moving map to location:", [service.location.lat, service.location.lng]);
                      mapRef.current.flyTo([service.location.lat, service.location.lng], 13);
                    } else {
                      console.log("Mobile mapRef.current is null");
                    }
                  } else {
                    console.log("Mobile service does not have a location");
                  }
                }
              }}

              

              // Loading states

              searchLoading={mapPageLoading}

              

              // Auto suggestions disabled

              autoSuggestions={[]}

              

              // Callbacks

              onFiltersExpandedChange={handleSearchFiltersExpandedChange}

              onHeightChange={handleSearchFiltersHeightChange}

              

              // Styling

              className="top-bar-global-search-filters"
              allowOverflow

            />

          </div>

          )}

        </div>

        {/* //* ====================== MAP ====================== */}

        <MapContainer

          style={mapContainerStyle}

          whenReady={handleMapReady}

          attributionControl={false}

          center={mapCenter}

          zoom={13}

          className="map-container dynamic-map-container"

          zoomControl={false}

          minZoom={3}

          maxZoom={22}

          maxBounds={mapMaxBounds}

        >

          <MapTiles darkMode={darkMode} />

          {userMarkerPosition && (

            <Marker

              zIndexOffset={-1}

              icon={userMarkerIcon}

              position={userMarkerPosition}

            />

          )}

          {activeTab === 'event' && Array.isArray(mapResults) && (() => {
            // Debug: Track debug events before map marker rendering
            const debugItems = mapResults.filter(item => 
              (item.type === 'event' && DEBUG_EVENT_NAMES.includes(item.name)) ||
              (item.type === 'venue' && (
                item.events?.some(event => DEBUG_EVENT_NAMES.includes(event.name)) ||
                (item._matchingEvent && DEBUG_EVENT_NAMES.includes(item._matchingEvent.name))
              ))
            );
            
            if (debugItems.length > 0) {
              mapDebugLogger.log(`🗺️ MARKER RENDER: Found ${debugItems.length} debug item(s) to render as markers`);
              debugItems.forEach(item => {
                mapDebugLogger.log(`   ${item.type}: "${item.name}" (ID: ${item._id})`);
                mapDebugLogger.log(`   Location: [${item.location?.coordinates?.[1]}, ${item.location?.coordinates?.[0]}]`);
                if (item.type === 'venue') {
                  mapDebugLogger.log(`   Matching Event: "${item._matchingEvent?.name || 'none'}"`);
                }
              });
            } else {
              mapDebugLogger.log(`🗺️ MARKER RENDER: No debug events found in ${mapResults.length} map markers`);
            }
            
            return true; // Just return true to continue the render
          })() &&
            mapResults.map((event, i) => (

                <MapMarker

                  key={event._id || event.id || i}

                  selected={selectedEventId === event._id}

                  // Icon calculation is now handled inside MapMarker component

                  // position={

                  //   event?.location?.coordinates

                  //     ? [event.location.coordinates[1], event.location.coordinates[0]]

                  //     : [0, 0]

                  // }

                  title={event.name}

                  // onClick={handleMarkerClick(event)}
                  
                  clickHandler={handleMarkerClick}
                  
                  event={event}

                  smallIcon={smallIcon}

                  tagFilter={tagFilter}

                />

            ))}

          {activeTab === "venue" &&
            (() => {
              if (selectedEvent?.type === "venue") {
                const coordinates = getMapItemCoordinates(selectedEvent);
                if (!coordinates) return null;

                return (
                  <MapMarker
                    key={selectedEvent._id || selectedEvent.id || "selected-venue"}
                    selected
                    icon={createVenueIcon(true)}
                    position={[coordinates[1], coordinates[0]]}
                    title={selectedEvent.name}
                    clickHandler={handleVenueClick}
                    event={selectedEvent}
                    smallIcon={smallIcon}
                    tagFilter={tagFilter}
                  />
                );
              }

              if (!Array.isArray(mapLocations)) return null;

              return mapLocations.map((venue, i) => {
                const coordinates = getMapItemCoordinates(venue);
                if (!coordinates) return null;

                return (
                  <MapMarker
                    key={venue._id || venue.id || i}
                    selected={selectedEventId === venue._id}
                    icon={createVenueIcon(false)}
                    position={[coordinates[1], coordinates[0]]}
                    title={venue.name}
                    clickHandler={handleVenueClick}
                    event={venue}
                    smallIcon={smallIcon}
                    tagFilter={tagFilter}
                  />
                );
              });
            })()}


        </MapContainer>

      </div>

    </div>

  );

};



// Memoize Map component to prevent unnecessary re-renders
const MemoizedMap = React.memo(Map, (prevProps, nextProps) => {
  // Map component has no props, so it should only re-render when context values change
  // The memoization will prevent re-renders when parent components re-render
  // but context changes will still trigger re-renders as expected
  return true; // Always prevent re-render unless context changes
});

export default MemoizedMap;

